var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0155 0.508789H4.98449C2.23163 0.508789 0 2.74042 0 5.49328V12.5073C0 15.2602 2.23163 17.4918 4.98449 17.4918H19.0155C21.7684 17.4918 24 15.2602 24 12.5073V5.49328C24 2.74042 21.7684 0.508789 19.0155 0.508789ZM15.6445 9.34155L9.08177 12.4716C8.9069 12.555 8.7049 12.4275 8.7049 12.2338V5.77805C8.7049 5.58158 8.91221 5.45424 9.08744 5.54305L15.6502 8.86874C15.8453 8.9676 15.8419 9.24743 15.6445 9.34155Z",
    fill: "#F61C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d4176763810e9225792219f8bef12f32.svg";
export { ForwardRef as ReactComponent };